'use strict';

var _ = require('lodash');
var ChartDashboardClassFareService = function ChartDashboardClassFareService($q, dataRetrieverService, dataRetrieverConstantsService, classIndicesService, dashboardCommonService, momentService, fcrService) {
  var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.DASHBOARD_SCREEN, dataRetrieverConstantsService.MARKET_DASHBOARD_MODE);
  var bookedFareAvgForAllGroups, bookedFareAvgForAllGroupsLY;
  function aggregate(cogOption, data) {
    bookedFareAvgForAllGroups = 0;
    bookedFareAvgForAllGroupsLY = 0;
    var result = [];
    var selectedDateRange = calculateChartDateRange(data);
    var selectedBrushes = dashboardCommonService.getMarketsAndPosesBrush();
    var selectedMarket = _.get(selectedBrushes, 'market[0]', false);
    var selectedMarketWithFcrTag = fcrService.getFcrTagForMultipleEntitiesWithMarket(selectedMarket, selectedDateRange);
    var groupedData = _.groupBy(data, cogOption);
    var totalAverageBookedFare = 0,
      totalAverageBookedFareLY = 0,
      totalYoyChange = 0;
    for (var groupName in groupedData) {
      var bookedFare = 0,
        totalBookings = 0,
        bookedFareLY = 0,
        totalBookingsLY = 0,
        expectedBookings = 0,
        expectedBookingsLY = 0;
      var fareValues = [];
      var fareValuesLY = [];
      for (var i = 0, length = groupedData[groupName].length; i < length; i++) {
        var element = groupedData[groupName][i];
        bookedFare += element.currentClassBookings * element.currentClassFare;
        totalBookings += element.currentClassBookings;
        bookedFareLY += element.lyClassBookings * element.lyClassFare;
        totalBookingsLY += element.lyClassBookings;
        fareValues.push(element.currentClassFare);
        fareValuesLY.push(element.lyClassFare);
        expectedBookings += element.expectedBookings;
        expectedBookingsLY += element.finalBookingsLY;
      }
      var averageBookedFare = totalBookings ? bookedFare / totalBookings : 0;
      var averageBookedFareLY = totalBookingsLY ? bookedFareLY / totalBookingsLY : 0;
      var currBookingsChange = totalBookingsLY ? (totalBookings / totalBookingsLY - 1) * 100 : 0;
      var expBookingsChange = expectedBookingsLY ? (expectedBookings / expectedBookingsLY - 1) * 100 : 0;
      var averageFare = getAverageValue(_.values(fareValues));
      var averageFareLY = getAverageValue(_.values(fareValuesLY));
      var dotValue = averageFareLY ? (averageFare / averageFareLY - 1) * 100 : 0;
      var metrics = {
        curr: totalBookings,
        exp: expectedBookings,
        currRef: totalBookingsLY,
        finalRef: expectedBookingsLY,
        currBookingsChange: currBookingsChange,
        expBookingsChange: expBookingsChange,
        avgFare: averageFare,
        avgFareLY: averageFareLY,
        fareChange: dotValue
      };
      var bar = {
        xLabel: groupName,
        stackLabel: groupName,
        barValue: expBookingsChange,
        circles: [{
          value: dotValue,
          css: 'dot-under'
        }],
        metrics: metrics
      };
      totalAverageBookedFare += averageBookedFare;
      totalAverageBookedFareLY += averageBookedFareLY;
      totalYoyChange += dotValue;
      result.push(bar);
    }
    if (result.length > 0) {
      bookedFareAvgForAllGroups = totalAverageBookedFare / result.length;
      bookedFareAvgForAllGroupsLY = totalAverageBookedFareLY / result.length;
      var indices = cogOption === 'className' ? classIndicesService.prepareClassIndices(selectedMarketWithFcrTag) : classIndicesService.prepareClassGroupIndices(selectedMarketWithFcrTag);
      return _.chain(result).map(function (v) {
        return _.extend(v, {
          idx: indices[v.xLabel]
        });
      }).sortBy(['idx', 'xLabel']).map(_.curryRight(_.omit, 2)('idx')).value();
    }
    return result;
  }
  function calculateChartDateRange(data) {
    var selectedMonths = _.chain(data).map(function (item) {
      return _.pick(item, ['month', 'year']);
    }).uniqWith(_.isEqual).sortBy(['year', 'month']).value();
    return [momentService.of(new Date(selectedMonths[0].year, selectedMonths[0].month), momentService.FIELD.DASHBOARD_DATE), momentService.of(new Date(selectedMonths[selectedMonths.length - 1].year, selectedMonths[selectedMonths.length - 1].month), momentService.FIELD.DASHBOARD_DATE).endOf('month').add(-1, 'second')];
  }
  function getAverageValue(valuesArray) {
    var sum = valuesArray.reduce(function (a, b) {
      return a + b;
    });
    return sum / valuesArray.length;
  }
  function getDataSummary() {
    return {
      avgBookedFare: bookedFareAvgForAllGroups,
      avgBookedFareLY: bookedFareAvgForAllGroupsLY,
      yoyChange: bookedFareAvgForAllGroupsLY ? (bookedFareAvgForAllGroups / bookedFareAvgForAllGroupsLY - 1) * 100 : 0
    };
  }
  function getData(cogOption) {
    return dataRetriever.localSortApplied().retrieveComponentData('dashboard-class-fare').then(aggregate.bind(null, cogOption));
  }
  return {
    getData: getData,
    getDataSummary: getDataSummary
  };
};
ChartDashboardClassFareService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ClassIndicesService', 'DashboardCommonService', 'MomentService', 'FcrService'];
module.exports = ChartDashboardClassFareService;